import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import { ctxReport } from '@/contexts/ReportCtx';
import { createReport } from '@/generated/client/reports/reports';
import { useNotificationStore } from '@/stores/notificationstore';

export function GenerateButton() {
  const { t } = useTranslation();
  const reportCtx = useContext(ctxReport);
  const showNotification = useNotificationStore((state) => state.showNotification);

  async function generateReports() {
    if (
      !reportCtx ||
      reportCtx.selectedTemplateIds.length == 0 ||
      !reportCtx.selectedDates ||
      !reportCtx.addressee ||
      ((!reportCtx.selectedTargets || reportCtx.selectedTargets.length == 0) &&
        (!reportCtx.selectedDrivers || reportCtx.selectedDrivers.length == 0))
    ) {
      showNotification('info', t('report.noDataSelected'), () => {}, 5);
      return;
    }
    const targetIds = reportCtx.selectedTargets ? reportCtx.selectedTargets.map((target) => target.id) : [];
    const driverIds = reportCtx.selectedDrivers ? reportCtx.selectedDrivers.map((driver) => driver.id) : [];
    const selectedDates = reportCtx.selectedDates;
    const fromTimeMillis = selectedDates.from.getTime();
    const toTimeMillis = selectedDates.to.getTime();
    const request = {
      targetIds: targetIds,
      fromTimeMillis: fromTimeMillis,
      toTimeMillis: toTimeMillis,
      driverIds: driverIds,
      templateIds: reportCtx.selectedTemplateIds,
      addressee: reportCtx.addressee,
    };
    await createReport(request);
    showNotification('info', t('report.successfulReport'), () => {}, 5);
  }
  return (
    <Button variant="contained" color="secondary" onClick={generateReports} className="report-generate-button">
      {t('tachograph.downloadButton.send')}
    </Button>
  );
}
